module.exports = __webpack_public_path__ + "img/blog-11.c00d139a.jpg";